export const NACHWEIS_DOC_PREFIX = 'nachweis-'

export function isNachweisDocName(name: string): boolean {
  return name.startsWith(NACHWEIS_DOC_PREFIX)
}
